
const inactivityMixin = {
    data() {
        return {
            inactivityTimer: null,
            inactivityTimeout: 10 * 60 * 1000,
            events: ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart']
        }
    },

    mounted() {
        this.setupInactivityTimer()
        this.bindEvents()
    },

    beforeDestroy() {
        this.removeEvents()
        this.clearTimer()
    },

    methods: {
        setupInactivityTimer() {
            this.resetTimer()
        },

        bindEvents() {
            this.events.forEach(event => {
                window.addEventListener(event, this.resetTimer)
            })
        },

        removeEvents() {
            this.events.forEach(event => {
                window.removeEventListener(event, this.resetTimer)
            })
        },

        resetTimer() {
            this.clearTimer()
            this.inactivityTimer = setTimeout(this.logoutDueToInactivity, this.inactivityTimeout)
        },

        clearTimer() {
            if (this.inactivityTimer) {
                clearTimeout(this.inactivityTimer)
                this.inactivityTimer = null
            }
        },

        async logoutDueToInactivity() {
            // Mostrar advertencia primero
            if (await this.showInactivityWarning()) {
                await this.performLogout()
            }
        },

        async showInactivityWarning() {
            return new Promise((resolve) => {
                this.$confirm({
                    message: `Su sesión ha sido cerrada por inactividad.`,
                    button: {
                        yes: "Ok",
                    },
                    callback: (confirm) => {
                        if (confirm) {
                            resolve(true)
                        }
                    },
                });


                // // Usar tu sistema de notificaciones o modal
                // this.$notify({
                //     type: 'warning',
                //     title: 'Inactividad',
                //     message: 'La sesión se cerrará por inactividad en 30 segundos',
                //     duration: 30000,
                //     onClick: () => {
                //         this.resetTimer()

                //     }
                // })

                // // Dar 30 segundos para que el usuario responda
                // setTimeout(() => resolve(true), 30000)
            })
        },

        async performLogout() {
            try {
                await this.$axios.post('/logout')
                localStorage.removeItem('access_token')
                this.$router.push('/')
            } catch (error) {
                localStorage.removeItem('access_token')
                this.$router.push('/')
            }
        }
    }
}

export { inactivityMixin };